// ISOCertification.jsx
import React from "react";

export default function ISOCertification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISO Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISO Certification Support for Organizations
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists organizations in obtaining ISO
            Certification for quality and compliance standards, supporting
            implementations aligned with frameworks like ISO 9001 and related
            management system standards.[web:314][web:318]
          </p>
          <p className="text-gray-700">
            Support typically spans gap assessment, documentation, training, and
            coordination with accredited certification bodies to help achieve
            and maintain certification.[web:311][web:317]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/5668841/pexels-photo-5668841.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Business team reviewing quality manuals and compliance documents"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISO Certification
            </h2>
            <p className="text-gray-700 mb-4">
              Certification bodies and auditors generally look for clear
              business identity and structured quality documentation that
              reflects the implemented management system.[web:310][web:311][web:315]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Business registration details such as incorporation
                  certificate, PAN, and basic address proofs to define the
                  organization and scope of certification.[web:310][web:314][web:315]
                </li>
                <li>
                  Process documentation, including standard operating procedures,
                  work instructions, and records that demonstrate how key
                  activities are planned and controlled.[web:311][web:313][web:317]
                </li>
                <li>
                  Quality manuals or equivalent documented information describing
                  policies, objectives, process interactions, and responsibilities
                  under the chosen ISO standard.[web:311][web:313]
                </li>
                <li>
                  Supporting records such as internal audit reports, management
                  review minutes, and corrective action logs, often examined
                  during certification audits.[web:313][web:317]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The service is structured to translate ISO requirements into
              practical, organisation‑specific systems rather than generic
              templates.[web:311][web:317]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  ISO Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on interpreting clauses, defining scope, and mapping
                  existing processes to ISO requirements for standards such as
                  ISO 9001 and related frameworks.[web:311][web:313][web:317]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Certification Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Stepwise support from gap analysis and documentation through
                  implementation, internal audits, and certification audit
                  coordination.[web:314][web:317]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Guidance
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing advisory input to address non‑conformities and sustain
                  compliance during surveillance and recertification cycles.[web:314][web:318]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
